import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static targets = [ "switch", "checkbox" ];

    connect() {
        console.log('search controller connected', this.element)
        if (this.hasSwitchTarget) {
            this.update_switch();
        }
    }

    toggle(event) {
        const classes = this.switchTarget.classList;
        const current = classes.contains('active');
        document.querySelectorAll('.toggle-switch.active').forEach((tog) => tog.classList.remove('active'));

        if (current) {
            classes.remove('active');
        } else {
            classes.add('active');
        }
        event.stopPropagation();
    }

    update_switch() {
        const boxes = this.checkboxTargets;
        const selected = boxes.some(b => b.checked);
        const classes = this.switchTarget.classList;
        if (selected) {
            classes.remove('empty');
        } else {
            classes.add('empty');
        }
    }

    // reset all inputs in search
    reset() {
        const search = $(this.element).closest('form');
        search.find('input[type="search"]').val(null);
        search.find('input[type="text"]').val(null);
        search.find('input[type="checkbox"]').prop('checked', false);
        search.find('.toggle-switch').addClass('empty');
    }
    submit() {
        const search = $(this.element).closest('form');
        search.find('input[type="search"]').trigger('change');
    }
}